var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.62103C1 0.945648 1.82277 0.61438 2.29076 1.10134L14.7688 14.085C15.2268 14.5616 14.889 15.3547 14.228 15.3547H1.75C1.33579 15.3547 1 15.0189 1 14.6047V1.62103Z",
    stroke: "#2B2B35",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTriangle);
export default __webpack_public_path__ + "static/media/right_triangle.be48d8df4d31b5c94d674af5012b8ac3.svg";
export { ForwardRef as ReactComponent };